<script>

</script>


<div class="title-block">
  <img src="images/logo.png" alt="">
</div>




<style>
.title-block {
  /* width: 28%; */
  width: 400px;
  position: relative;
  background: #00a7e6;
  padding: 20px;
  padding-bottom: 0;
  z-index: 2;
  /* margin-bottom: 80px; */
}
.title-block::after {
  content: "";

  background-position: top right;
  background-repeat: no-repeat;

  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 80px;
}

img {
  max-width: 100%;
  transform: translateX(-4%);
}

@media screen and (max-width: 800px) {
  .title-block {
    width: 186px;
    max-width: 300px;
    /* margin-bottom: 80px; */
    padding-bottom: 10px;
  }

  .title-block::after {
    height: 50px;
    left: -1px;
    right: 0;
  }

}


</style>
